<template>
  <section class="onboarding-modal__step">
    <div class="onboarding-modal__step-badge">{{ stepBadgeLabel }}</div>
    <div class="onboarding-modal__step-header">
      <div class="onboarding-modal__step-title">
        Select your Learning Area of interest
      </div>
      <div class="onboarding-modal__step-info">
        Help us cater the right kind of content to you.
      </div>
    </div>
    <div class="interest-area__items-wrapper">
      <div
        v-for="(area, i) in insterestAreas"
        :key="`area-${i}`"
        :class="[
          'interest-area__item',
          isAreaSelected(area.name) && 'interest-area__item--selected',
        ]"
        @click="toggleAreaSelection(area.name)"
      >
        <Passes class="interest-area__item-icon" :passName="area.name" />
        <div class="interest-area__item-label">
          {{ area.name }}
        </div>
        <span class="ine-checkbox__input interest-area__item-checkbox-input">
          <input
            type="checkbox"
            :id="area.name"
            :name="`${area.name}-checkbox`"
            :value="area.name"
            v-model="currentSelection"
          />
          <span
            class="ine-checkbox__control interest-area__item-checkbox-control"
          >
            <CheckboxTick />
          </span>
        </span>
      </div>
    </div>
    <div class="onboarding-modal__step-btn-wrapper">
      <button
        type="submit"
        class="btn btn--primary onboarding-modal__step-save-btn"
        :disabled="isSaveDisabled"
        @click="saveInterestArea()"
      >
        Save Interests
      </button>
      <button
        @click="$emit('go-next-step')"
        class="btn btn--secondary onboarding-modal__step-next-btn"
      >
        Skip this step
      </button>
      <button
        v-if="!isFirstStep"
        @click="$emit('go-previus-step')"
        class="btn btn--tertiary onboarding-modal__step-back-btn"
      >
        Back
      </button>
    </div>
  </section>
</template>

<script>
import CONSTANTS from '@/constants'
import Passes from '@/components/properties/Passes.vue'
import CheckboxTick from '@/assets/images/certification/checkbox-tick.svg'

export default {
  name: 'InterestArea',
  components: {
    Passes,
    CheckboxTick: { ...CheckboxTick, name: 'CheckboxTick' },
  },
  props: {
    stepBadgeLabel: {
      type: String,
      required: true,
    },
    onboardingSurvey: {
      type: Object,
      required: true,
    },
    profilePreferences: {
      type: Object,
      required: true,
    },
    isFirstStep: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isSaveDisabled: true,
      currentSelection: '',
    }
  },
  computed: {
    insterestAreas() {
      return CONSTANTS.LEARNING_AREAS.PRIMARY
    },
  },
  watch: {
    currentSelection() {
      const profileAreaSelected = this.profilePreferences?.primary_interest
      if (!this.isAreaSelected(profileAreaSelected)) this.isSaveDisabled = false
    },
  },
  methods: {
    toggleAreaSelection(areaName) {
      this.currentSelection = [areaName]
    },
    isAreaSelected(area) {
      return this.currentSelection.includes(area)
    },
    async saveInterestArea() {
      if (!this.currentSelection?.length) return
      const interestArea = this.currentSelection[0]
      this.isSaveDisabled = true
      this.$emit('set-loader', true)
      try {
        await this.$store.dispatch('auth/submitProfilePreferences', {
          ...this.profilePreferences,
          primary_interest: interestArea,
        })
        const message = 'Your interest area has been successfully updated!'
        await this.$store.dispatch('app/setNotification', message)
        if (!this.onboardingSurvey?.data?.learning_areas) {
          const onboardingSurvey = {
            ...this.onboardingSurvey.data,
            learning_areas: true,
          }
          await this.$store.dispatch(
            'auth/setOnboardingSurvey',
            onboardingSurvey
          )
        }
        this.$emit('go-next-step')
      } catch (e) {
        this.isSaveDisabled = false
      } finally {
        this.$emit('set-loader', false)
      }
    },
  },
  created() {
    this.$emit('set-component-loader', true)
    this.toggleAreaSelection(this.profilePreferences?.primary_interest)
    this.$emit('set-component-loader', false)
  },
}
</script>

<style lang="scss" scoped>
.interest-area {
  &__items-wrapper {
    margin-bottom: 32px;
    @include mobile {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
    }
    @include tablet {
      flex-direction: column;
      gap: 10px;
    }
  }
  &__item {
    font-size: rem(16);
    display: flex;
    align-items: center;
    line-height: 24px;
    color: var(--white);
    padding: 10px;
    margin-bottom: 5px;
    border-radius: 10px;
    border: 1px solid transparent;
    height: 50px;
    cursor: pointer;
    @include mobile {
      height: 100px;
      padding: 30px;
      width: calc(50% - 5px);
      margin-bottom: 0;
    }
    @include tablet {
      padding: 10px;
      height: 70px;
      width: 100%;
    }
    &-icon {
      width: 30px;
      @include tablet {
        width: 50px;
      }
    }
    &-label {
      margin-left: 10px;
    }
    &--selected,
    &:hover {
      background: var(--glass-mid-gray);
      border: 1px solid var(--tundora-gray);
    }
  }
  &__item-checkbox {
    &-input {
      cursor: pointer;
      margin-left: auto;
    }
    &-control {
      width: 24px;
      height: 24px;
      border-radius: 8px;
      pointer-events: none;
      border: 1px solid var(--white);
      svg {
        width: 8px;
      }
    }
  }
}
</style>
